import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/index";
const axios = require("axios");

const initialState = {
  loading: false,
  error: false,
  data: [],
};

const collectionsSlice = createSlice({
  name: "collections",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllCollections.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCollections.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllCollections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const getAllCollections = createAsyncThunk(
  "collectionsSlice/getAllCollections",
  async () => {
    try {
      const { url, method, headers } = api.getAllCollections();
      const referents = await axios({
        url,
        method,
        headers,
      });
      return referents.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const { actions } = collectionsSlice;
export default collectionsSlice.reducer;
